import { formatISO } from 'date-fns';
import { DriverDetailsFormItem } from '../../components/manage-drivers/types';
import { capitalizeFirstLetter, generateDate } from '../../utils';
import { DriverFormValues } from '../../utils/initialValues/get-driver-form-values';
import IDate from '../../utils/types/date';
import { getLicenceNumber } from '../../utils/transform/get-licence-number';

// Legacy transforms lifted and shifted from the additional driver form (now DriverForm)
export const getDriverFromFullForm = (formValues: DriverFormValues): DriverDetailsFormItem => {
	const dob = generateDate(formValues.dateOfBirth);
	const ukResidenceSince = formValues.ukResidenceSince?.day
		? generateDate(formValues.ukResidenceSince as IDate)
		: undefined;
	const licenceObtained = generateDate(formValues.licenceObtained);

	const newDriver: DriverDetailsFormItem = {
		...formValues,
		firstName: capitalizeFirstLetter(formValues.firstName),
		lastNames: capitalizeFirstLetter(formValues.lastNames),
		dateOfBirth: formatISO(dob, { representation: 'date' }),
		isResidentFromBirth: formValues.isResidentFromBirth === 'yes',
		ukResidenceSince: ukResidenceSince ? formatISO(ukResidenceSince, { representation: 'date' }) : undefined,
		isMainDriver: false,
		licenceObtained: formatISO(licenceObtained, { representation: 'date' }),
		licenceNumber: getLicenceNumber(formValues.licenceNumber, formValues.licenceType),
		hasCriminalConvictions: formValues.hasCriminalConvictions === 'yes',
		hasBeenRefusedCover: formValues.hasBeenRefusedCover === 'yes',
		accessToOtherVehicles: formValues.accessToOtherVehicles === 'yes',
		numberOfVehiclesOwned: 0,
		numberOfVehiclesAccessTo: 0,
		isNewDriver: true,
		badgePassedDate: formValues.badgePassedDate
			? formatISO(generateDate(formValues.badgePassedDate), { representation: 'date' })
			: undefined,
		driverUsage: formValues.driverUsage ?? undefined,
		employmentStatus: formValues.employmentStatus === 'no' ? 'PT' : 'FT',
		otherEmploymentStatus: formValues.otherEmploymentStatus === 'no' ? 'PT' : 'FT',
		otherEmploymentType: formValues.otherEmploymentType,
		otherIndustry: formValues.otherIndustry,
		otherOccupation: formValues.otherOccupation,
		otherEmployment: formValues.otherEmployment,
	};
	return newDriver;
};
